import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert,  Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { CrsConfig, sbConfig } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface CrsConfigViewProps {
    gsb: AxiosInstance,
    CrsConfig: CrsConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function CrsConfigView({ gsb, CrsConfig = {} as CrsConfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: CrsConfigViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)

     const [CHQ_NAME, setCHQ_NAME] = useState(false)
     const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
     const [CM2K_USER, setCM2K_USER] = useState(false)
 
   
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setSUSPEND_AC(GsbFlag.SUSPEND_AC)               
                setCHQ_NAME(GsbFlag.CHQ_NAME)
                setCM2K_USER( GsbFlag.CM2K_USER);
                //console.log("set StatusList: ", StatusList)
 
             

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, CrsConfig ])
   /* if (! ("d_tr_date" in CrsConfig)) return null*/
    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                
            </div>
            <div className="Spacing-V-16" />
            {/*
            <div className="Row">
                <FormGroup className="Col-1-2" label="System Date">
                    <InputGroup readOnly value= {utils.dispDate(CrsConfig.d_tr_date, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-3" label="AOEI ID">
                    <InputGroup readOnly value={CrsConfig.d_AOEI_ID} />
                </FormGroup>

                <FormGroup className="Col-4-3" label="Sending CompIN">
                    <InputGroup readOnly value={CrsConfig.d_SendingCompIN} />
                </FormGroup>
            </div>
            {/*
            <div className="Row">
                <FormGroup className="Col-1-3" label="Company GIIN ">
                    <InputGroup readOnly value={CrsConfig.d_GIIN} />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-6" label="Co Name">
                    <InputGroup readOnly value={CrsConfig.d_Co_Name} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-6" label="Co Address">
                    <InputGroup readOnly value={CrsConfig.d_Co_Address} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
    
            { SUSPEND_AC && <div className="Row">  
                    <FormGroup className="Col-1-3" label="Allow Delete CRS Client" labelFor="inputAllowDelCRSClient">
                    <RadioGroup
                        name="AllowDelCRSClient"
                        disabled={true}
                        inline={true}
                        selectedValue={CrsConfig.d_AllowDelCRSClient}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>}
            <div className="Spacing-V-16" />          
            { CHQ_NAME && <div className="Row">
                <FormGroup className="Col3-1-2" label="GSB import to CRS Name by" >
                    {(CrsConfig.d_CRS_importNameby == "NAME" ||  CrsConfig.d_CRS_importNameby.trim().length === 0)
                     ?   <InputGroup readOnly value="Name" />   
                     :   <InputGroup readOnly value="Cheque Name" />                       
                    }                  
                </FormGroup>
            </div> }

            { SUSPEND_AC && <div className="Row">     
                <FormGroup className="Col-1-3" label="Other Active AC STATUS in HKCRS Master" labelFor="inputCRS_OTHER_ACTIVE">
                        <InputGroup readOnly id="inputBCAN_OTHER_ACTIVE" name="d_CRS_OTHER_ACTIVE" value={(CrsConfig.d_CRS_OTHER_ACTIVE)} />
                </FormGroup>
            </div>  }


            <div className="Row">
                <FormGroup className="Col-1-3" label="Remove special Character when import to CRS" labelFor="inputCRS_Remove_Speical_Char">
                        <InputGroup readOnly id="inputCRS_Remove_Speical_Char" name="d_CRS_Remove_Speical_Char" value={(CrsConfig.d_CRS_Remove_Speical_Char)} />
                </FormGroup>
            </div>                
            { SUSPEND_AC && <div className="Row">     
                <FormGroup className="Col-1-3" label="Exclusive AC Status Import to CRS" labelFor="inputCRS_Exclusive_AC_Status_Import">
                        <InputGroup readOnly id="inputCRS_Exclusive_AC_Status_Import" name="d_CRS_Exclusive_AC_Status_Import" value={(CrsConfig.d_CRS_Exclusive_AC_Status_Import)} />
                </FormGroup>
            </div> }   
      
             {/*
             <div className="Row">
                <FormGroup className="Col-1-2" label="Enter to next input field" labelFor="inputEnter2Tab">
                    <RadioGroup
                        name="d_Enter2Tab"
                        disabled={true}
                        inline={true}
                        selectedValue={CrsConfig.d_Enter2Tab}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            */}
        </div>
    )
}

interface CrsConfigEditProps {
    gsb: AxiosInstance,
    CrsConfig?: CrsConfig,
    isNew?: boolean,
    onSave?: (CrsConfig: CrsConfig) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function CrsConfigEdit({ gsb, CrsConfig = {} as CrsConfig, isNew = false, onSave = () => { }, onCancel = () => { } }: CrsConfigEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<CrsConfig>()
  

    const [CHQ_NAME, setCHQ_NAME] = useState(false)    
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)  
    const [CM2K_USER, setCM2K_USER] = useState(false)
    
    const [def_CRS_importNameby, setdef_CRS_importNameby] = useState(CrsConfig.d_CRS_importNameby)

    const [AllowDelCRSClient,setAllowDelCRSClient ] =useState(CrsConfig.d_AllowDelCRSClient);  


    useEffect(() => {
        // Call reset to set default values if ac is passed

               
        if ("d_tr_date" in CrsConfig) {
            reset(CrsConfig)
        }
        
    }, [CrsConfig, reset])
    
    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setSUSPEND_AC(GsbFlag.SUSPEND_AC) ;              
                setCHQ_NAME(GsbFlag.CHQ_NAME);
                //console.log("set StatusList: ", StatusList)
                setCM2K_USER( GsbFlag.CM2K_USER);

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, CrsConfig])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])
    
    useEffect(() => {

         if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])    

   /* if (! isNew && !("d_tr_date" in CrsConfig)) return null*/


    const onSubmit = (data: CrsConfig) => {
        //console.log("onsubmit called", data)
        data.d_AOEI_ID = data.d_AOEI_ID.toUpperCase();
        data.d_AllowDelCRSClient = AllowDelCRSClient;
        // put value to json/field before write database dbf

        ;
        (async () => {
            try {
                //console.log("call CrsConfigedit data", data)
                //console.log("call CrsConfigedit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CrsConfig", cAction: "CrsConfigValidate", isNew: isNew})
                //console.log("CrsConfigedit res.data.ok", res.data.ok)
                //console.log("CrsConfigedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            {/*
            <div className="Row">
                <FormGroup className="Col-1-2" label="System Date">
                    <InputGroup disabled= {true} value= {utils.dispDate(CrsConfig.d_tr_date, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-3" label="AOEI ID">
                   <InputGroup id="inputCE_No" name="d_AOEI_ID" autoFocus={true}  defaultValue="" placeholder="AOEI ID..." inputRef={ register({ maxLength: 7}) } />
                        {errors.d_AOEI_ID && errors.d_AOEI_ID.types && <span id="Err_msg">{errors.d_AOEI_ID.types.message}</span>}
                        {errors.d_AOEI_ID && errors.d_AOEI_ID.type === "maxLength" && <span id="Err_msg">Max length is 7</span>}
                </FormGroup>
                
                <FormGroup className="Col-4-3" label="Sending CompIN">
                   <InputGroup id="inputSendingCompIN" name="d_SendingCompIN" autoFocus={true}  defaultValue="" placeholder="SendingCompIN..." inputRef={ register({ maxLength: 19}) } />
                        {errors.d_SendingCompIN && errors.d_SendingCompIN.types && <span id="Err_msg">{errors.d_SendingCompIN.types.message}</span>}
                        {errors.d_SendingCompIN && errors.d_SendingCompIN.type === "maxLength" && <span id="Err_msg">Max length is 19</span>}
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col-1-6" label="Co Name">
                <InputGroup id="inputCo_Name" name="d_Co_Name" autoFocus={true}  defaultValue="" placeholder="Co_Name.." inputRef={ register() } />
                    {errors.d_Co_Name && errors.d_Co_Name.types && <span id="Err_msg">{errors.d_Co_Name.types.message}</span>}
                    {/*errors.d_Co_Name && errors.d_Co_Name.type === "maxLength" && <span id="Err_msg">Max length is 6</span>*/}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-6" label="Co Address">
                <InputGroup id="inputCo_Address" name="d_Co_Address" autoFocus={true}  defaultValue="" placeholder="Co Address..." inputRef={ register() } />
                    {errors.d_Co_Address && errors.d_Co_Address.types && <span id="Err_msg">{errors.d_Co_Address.types.message}</span>}
                    {/*errors.d_Co_Address && errors.d_Co_Address.type === "maxLength" && <span id="Err_msg">Max length is 6</span>*/}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Allow Delete CRS Client" labelFor="inputAllowDelCRSCl">
                    <RadioGroup
                        name="Allow Del CRS Client"
                        inline={true}
                        selectedValue={AllowDelCRSClient}
                        onChange={utils.handleStringChange(s => setAllowDelCRSClient(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_AllowDelCRSClient && errors.d_AllowDelCRSClient.types && <span id="Err_msg">{errors.d_AllowDelCRSClient.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16"/>     
            { CHQ_NAME && <div className="Row">
                <FormGroup className="Col3-1-2" label="GSB import to CRS Name by" >
                     
                     <select  id="inputBcan_importby" name="d_CRS_importNameby" value={def_CRS_importNameby} onChange={utils.handleStringChange(s => setdef_CRS_importNameby(s)) }ref={register}>
                            <option value="NAME">Name</option>                        
                            <option value="CHQNAME">Cheque Name</option>
                        </select>
                    {errors.d_CRS_importNameby && errors.d_CRS_importNameby.types && <span id="Err_msg">{errors.d_CRS_importNameby.types.message}</span>}
                </FormGroup>
            </div> }
            { SUSPEND_AC && <div className="Row">  
                <FormGroup className="Col-1-3" label="Other Active AC STATUS in HKCRS Master" labelFor="inputCRS_OTHER_ACTIVE">
                <InputGroup id="inputBCAN_OTHER_ACTIVE" name="d_CRS_OTHER_ACTIVE" defaultValue="" placeholder="Other Active AC status in Master..." inputRef={ register({ maxLength: 5}) } />
                    {errors.d_CRS_OTHER_ACTIVE && errors.d_CRS_OTHER_ACTIVE.types && <span id="Err_msg">{errors.d_CRS_OTHER_ACTIVE.types.message}</span>}
                    {errors.d_CRS_OTHER_ACTIVE && errors.d_CRS_OTHER_ACTIVE.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                </FormGroup>
            </div> }

            <div className="Row">
                <FormGroup className="Col-1-3" label="Remove special Character when import to CRS" labelFor="inputCRS_Remove_Speical_Char">
                <InputGroup id="inputBCAN_Remove_Speical_Char" name="d_CRS_Remove_Speical_Char" defaultValue="" placeholder="special char for remove ..." inputRef={ register({ maxLength: 5}) } />
                    {errors.d_CRS_Remove_Speical_Char && errors.d_CRS_Remove_Speical_Char.types && <span id="Err_msg">{errors.d_CRS_Remove_Speical_Char.types.message}</span>}
                    {errors.d_CRS_Remove_Speical_Char && errors.d_CRS_Remove_Speical_Char.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                </FormGroup>
            </div>
            
            { SUSPEND_AC && <div className="Row">                      
                <FormGroup className="Col-1-3" label="Exclusive AC Status Import to CRS" labelFor="inputCRS_Exclusive_AC_Status_Import">
                <InputGroup id="inputCRS_Exclusive_AC_Status_Import" name="d_CRS_Exclusive_AC_Status_Import" defaultValue="" placeholder="exclusive AC status Import..." inputRef={ register({ maxLength: 5}) } />
                    {errors.d_CRS_Exclusive_AC_Status_Import && errors.d_CRS_Exclusive_AC_Status_Import.types && <span id="Err_msg">{errors.d_CRS_Exclusive_AC_Status_Import.types.message}</span>}
                    {errors.d_CRS_Exclusive_AC_Status_Import && errors.d_CRS_Exclusive_AC_Status_Import.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                </FormGroup>    
            </div> }
 
        </form>
    )
}

interface CrsConfigMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function CrsConfigMain({ gsb }: CrsConfigMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as CrsConfig[])

    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as CrsConfig)
    const [BlankAc, setBlankAc] = useState({} as CrsConfig)
    const [sbConfigRec, setsbConfigRec] = useState({} as sbConfig)

    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {

             
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("CrsConfigMain disp user_key: ", res.data.Flag.user_key)
                //console.log("CrsConfigMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("CrsConfigMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("CrsConfigMain disp GsbFlag: ", GsbFlag)
                //console.log("CrsConfigMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("CrsConfigMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("CrsConfigMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("CrsConfigMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("CrsConfigMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                if ( GsbFlag.isProduction == "Y" ) {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
} else {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
}
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {
        console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                // usually A/E code is prefixed with C, but some user may use others e.g. Upbest uses A for A/E
                // TODO: Read A/E prefix from config
                // fixed can read true A/E
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "CrsConfig",
                        cAction: "ListRec",
                    });
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                console.log("main res.data", res.data.data)
                console.log("main currentAc", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])



    const PrevRecProcess = async (CrsConfig: CrsConfig) => {
/*        
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CrsConfig", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const DeleteProcess = async (CrsConfig: CrsConfig) => {
/*        
        try {
            //console.log("call DeleteProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CrsConfig", cAction: "DelRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const NextRecProcess = async (CrsConfig: CrsConfig) => {
/*        
        try {
            //console.log("call NextRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CrsConfig", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }


    const newOnSave = async (CrsConfig: CrsConfig) => {
/*        
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "CrsConfig", cAction: "AddRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record added")

            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const editOnSave = async (CrsConfig: CrsConfig) => {
        try {
            console.log("call editOnSave", CrsConfig)
            const res = await gsb.post('/Master', {sb_data: CrsConfig, cPgmId: "CrsConfig", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data)
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <CrsConfigView gsb={gsb} CrsConfig={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></CrsConfigView>
    switch (currentMode) {
        case "edit":
            detail = <CrsConfigEdit gsb={gsb} CrsConfig={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></CrsConfigEdit>
            break
        case "new":
            detail = <CrsConfigEdit gsb={gsb} CrsConfig={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></CrsConfigEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    
    
    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>CRS Configuration</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default CrsConfigMain